
import ReactGA from "react-ga4";

// Simple analytics wrapper that supports consent gating (opt-in/opt-out)
const analytics = {
  enabled: false, // true when opt-in and initialization succeeded
  _measurementId: null,
  _initialized: false,
  init(measurementId) {
    // Store measurement id; do NOT initialize GA until optIn is called.
    this._measurementId = measurementId;
  },
  optIn() {
    try {
      if (this._initialized) {
        this.enabled = true;
        return;
      }
      if (process.env.REACT_APP_GA_DEBUG === "true" || (process.env.NODE_ENV === "production" && this._measurementId)) {
        ReactGA.initialize(this._measurementId, {send_page_view: false });
        this._initialized = true;
        this.enabled = true;
      } else {
        // In non-production or missing ID we keep enabled=false
        this.enabled = false;
      }
    } catch (e) {
      this.enabled = false;
    }
  },
  optOut() {
    // Disable analytics; keep GA initialized state as-is but stop sending events
    this.enabled = false;
  },
  pageview(path, fullUrl) {
    if (!this.enabled) return;
    try {
      // Send full URL (including fragment) as page_location for GA4
      // ReactGA.send({
      //   hitType: "pageview",
      //   page: path,
      //   page_location: fullUrl ? fullUrl : window.location.href
      // });
    } catch (e) {}
  },
  // name: short event name, params: object of parameters
  event(name, params = {}) {
    if (!this.enabled) return;
  // Safety check: only send if ReactGA is initialized and available
  if (typeof ReactGA?.event === 'function') {
    // This matches react-ga4's second overload: ReactGA.event(eventName, eventParams)
    ReactGA.event(name, params);
  } else {
    // Optional fallback for development or if GA fails to load
    console.warn('[Analytics] GA not initialized, event not sent:', name, params);
  }
  },
  setUser(userId, props = {}) {
    if (!this.enabled) return;
    try {
      if (userId) {
        ReactGA.set({ user_id: userId });
      }
      if (Object.keys(props).length > 0 && typeof ReactGA.gtag === "function") {
        ReactGA.gtag("set", props);
      }
    } catch (e) {}
  },
  isEnabled() {
    return this.enabled;
  },
};

// --- Game Lifecycle Analytics Helpers ---


analytics.trackLobbyJoined = function ({ userId, region }) {
  this.event("lobby_joined", {
    userId,
    region,
    timestamp: Date.now(),
  });
};

// Call these from your game logic for consistent event tracking
analytics.trackRoomCreated = function ({ gameType, roomId, userId, region }) {
  this.event("room_created", {
    gameType,
    roomId,
    userId,
    region,
    page_title: "Room Created",
    timestamp: Date.now(),
  });
};

analytics.trackRoomJoined = function ({ gameType, roomId, userId, region }) {
  this.event("room_joined", {
    gameType, 
    roomId,
    userId,
    region,
    page_title: "Room Joined",
    timestamp: Date.now(),
  });
}

analytics.trackGameStarted = function ({ gameType, roomId, playerCount, userId, region }) {
  this.event("game_started", {
    gameType,
    roomId,
    userId,
    region,
    playerCount,
    page_title: gameType + " Started",
    timestamp: Date.now(),
  });
};

analytics.trackGameStartedAgain = function ({ gameType, roomId, playerCount, userId, region }) {
  this.event("game_startedagain", {
    gameType,
    roomId,
    userId,
    region,
    playerCount,
    page_title: gameType + " Started Again",
    timestamp: Date.now(),
  });
};



analytics.trackGameCompleted = function ({ gameType, roomId, userId, region, durationMs, startedAt, finishedAt,playerCount }) {
  this.event("game_completed", {
    gameType,
    roomId,
    userId,
    region,
    durationMs,
    startedAt, 
    finishedAt,
    playerCount,
    timestamp: Date.now(),
  });
};

analytics.trackUserProfileUpdated = function ({ userId, region }) {
  this.event("user_profile_updated", {
    userId, 
    region,
    timestamp: Date.now(),
  });
};

// analytics.trackPlayerJoined = function ({ gameType, roomId, userId, region }) {
//   this.event("player_joined", {
//     gameType,
//     roomId,
//     userId,
//     region,
//     timestamp: Date.now(),
//   });
// };

// analytics.trackPlayerLeft = function ({ gameType, roomId, userId, region }) {
//   this.event("player_left", {
//     gameType,
//     roomId,
//     userId,
//     region,
//     timestamp: Date.now(),
//   });
// };

// analytics.trackGameError = function ({ gameType, roomId, userId, region, error }) {
//   this.event("game_error", {
//     gameType,
//     roomId,
//     userId,
//     region,
//     error: error?.toString?.() || String(error),
//     timestamp: Date.now(),
//   });
// };

export function hashId(id) {
  // Small non-cryptographic hash to avoid exposing raw room ids in analytics
  if (!id) return null;
  const s = String(id);
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return "r" + Math.abs(h).toString(36).slice(0, 8);
}

export default analytics;
